import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NewellUserAvatarComponent} from "./user-avatar/user-avatar.component";
import { NewellUserChipComponent } from './user-chip/user-chip.component';
import {NewellPostCardComponent} from "./post-card/post-card.component";
import {NewellUtilityModule} from "../utility";


const components = [
  NewellUserAvatarComponent,
  NewellPostCardComponent,
  NewellUserChipComponent,
];
@NgModule({
  declarations: [ ...components ],
  imports: [ CommonModule, NewellUtilityModule ],
  exports: [ ...components ]
})
export class NewellDisplayModule { }
